import styled from 'styled-components';
import {
  color, typography, textStyle, layout, space,
} from 'styled-system';
import themeGet from '@styled-system/theme-get';

interface TitleProps {
  children: React.ReactNode;
  as?: string;
  size?: string;
  textStyle?: string;
  fontSize?: string;
  fontFamily?: string;
  fontWeight?: string;
  lineHeight?: string;
  m?: string;
  my?: string;
  mx?: string;
  p?: string;
  py?: string;
  px?: string;
  textAlign?: string;
  maxWidth?: string;
  color?: string;
}

const StyledTitle = styled.h1<TitleProps>`
  font-weight: ${themeGet('fontWeights.semibold')};
  ${color};
  ${typography};
  ${textStyle};
  ${space};
  ${layout};
`;

export const HeroTitle = styled.h1`
  font-size: 38px;
  line-height: 50px;
  font-weight: ${themeGet('fontWeights.semibold')};
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    font-size: 44px;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    font-size: 67px;
    line-height: 78px;
  }
  ${color};
  ${typography};
  ${textStyle};
  ${space};
`;

export const StyledH1 = styled.h1`
  font-size: 38px;
  line-height: 50px;
  font-weight: ${themeGet('fontWeights.semibold')};
  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    font-size: 78px;
    line-height: 78px;
  }
  ${color};
  ${typography};
  ${textStyle};
  ${space};
`;

export const StyledH2 = styled.h2`
  font-size: clamp(2rem, 1.75rem + 1.0761vw, 2.55rem);
  line-height: clamp(2.22rem, 1.8717rem + 1.7413vw, 3.11rem);
  font-weight: ${themeGet('fontWeights.semibold')};

  ${color};
  ${typography};
  ${textStyle};
  ${space};
`;

export const StyledH3 = styled.h3`
  font-size: 25px;
  line-height: 30px;
  font-weight: ${themeGet('fontWeights.semibold')};
  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    font-size: 30px;
  }
  ${color};
  ${typography};
  ${textStyle};
  ${space};
`;

export const StyledH4 = styled.h4`
  font-size: 18px;
  line-height: 48px;
  font-weight: ${themeGet('fontWeights.semibold')};
  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    font-size: 22px;
  }
  ${color};
  ${typography};
  ${textStyle};
  ${space}
`;

export const FAQTitle = styled.h2`
  font-size: 18px;
  line-height: 23px;
  font-weight: ${themeGet('fontWeights.semibold')};
  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    font-size: 20px;
    line-height: 25px;
  }
  @media only screen and (min-width: ${themeGet('breakpoints.xl')}) {
    font-size: 21px;
    line-height: 30px;
  }
  ${color};
  ${typography};
  ${textStyle};
  ${space}
`;

export const GlossaryTitle = styled.h2`
  font-size: 30px;
  line-height: 44px;
  font-weight: ${themeGet('fontWeights.bold')};
  ${color};
  ${typography};
  ${textStyle};
  ${space}
`;

export const FAQCatTitle = styled.h3`
  font-size: 30px;
  line-height: 37px;
  font-weight: ${themeGet('fontWeights.bold')};
  color: ${themeGet('colors.blue')};
  ${color};
  ${typography};
  ${textStyle};
  ${space}
`;

export const FATCatSubTitle = styled.h3`
  font-size: 30px;
  line-height: 37px;
  font-weight: ${themeGet('fontWeights.bold')};
  color: black;
  ${color};
  ${typography};
  ${textStyle};
  ${space}
`;

export const FAQCatQuestion = styled.h4`
  font-size: 18px;
  line-height: 20px;
  font-weight: ${themeGet('fontWeights.bold')};
  color: ${themeGet('colors.blue')};
  ${color};
  ${typography};
  ${textStyle};
  ${space}
`;

export default StyledTitle;
